module.exports = __webpack_public_path__ + "static/13-2df95c0670e33218379ec3f4262fc6eb.jpeg";